export const PeriodoFechadoModais = {
  editarNotaExplicativa: 'editarNotaExplicativa',
};